{
  "GENERAL_SETTINGS": {
    "LIMIT_MESSAGES": {
      "CONVERSATION": "Has superat el límit de converses. El pla Hacker només permet 500 converses.",
      "INBOXES": "Has superat el límit de safates d'entrada. El pla Hacker només admet el xat en directe del lloc web. Les safates d'entrada addicionals com correu electrònic, WhatsApp, etc. requereixen un pla de pagament.",
      "AGENTS": "Has superat el límit d'agents. El pla Hacker només permet 2 agents.",
      "NON_ADMIN": "Contacta amb l'administrador per actualitzar el pla i continuar utilitzant totes les funcions."
    },
    "TITLE": "Configuració del compte",
    "SUBMIT": "Actualització de la configuració",
    "BACK": "Enrere",
    "DISMISS": "Descartar",
    "UPDATE": {
      "ERROR": "No s'ha pogut actualitzar la configuració, torna-ho a provar!",
      "SUCCESS": "La configuració del compte s'ha actualitzat correctament"
    },
    "ACCOUNT_DELETE_SECTION": {
      "TITLE": "Suprimeix el teu compte",
      "NOTE": "Un cop suprimeixis el teu compte, totes les teves dades se suprimiran.",
      "BUTTON_TEXT": "Suprimeix el teu compte",
      "CONFIRM": {
        "TITLE": "Suprimeix el compte",
        "MESSAGE": "Suprimir el teu compte és irreversible. Introdueix el nom del teu compte a continuació per confirmar que vols suprimir-lo de manera permanent.",
        "BUTTON_TEXT": "Suprimeix",
        "DISMISS": "Cancel·la",
        "PLACE_HOLDER": "Escriu {accountName} per confirmar"
      },
      "SUCCESS": "Compte marcat per a supressió",
      "FAILURE": "No s'ha pogut suprimir el compte, torna-ho a provar!",
      "SCHEDULED_DELETION": {
        "MESSAGE_MANUAL": "Aquest compte està programat per suprimir-se el {deletionDate}. Ho ha sol·licitat un administrador. Pots cancel·lar la supressió abans d'aquesta data.",
        "MESSAGE_INACTIVITY": "Aquest compte està programat per suprimir-se el {deletionDate} a causa d'inactivitat. Pots cancel·lar la supressió abans d'aquesta data.",
        "CLEAR_BUTTON": "Cancel·la la supressió programada"
      }
    },
    "FORM": {
      "ERROR": "Corregiu els errors del formulari",
      "GENERAL_SECTION": {
        "TITLE": "Configuració general",
        "NOTE": ""
      },
      "ACCOUNT_ID": {
        "TITLE": "ID del compte",
        "NOTE": "Aquest identificador és necessari si esteu creant una integració basada en API"
      },
      "NAME": {
        "LABEL": "Nom del compte",
        "PLACEHOLDER": "El nom del vostre compte",
        "ERROR": "Introduïu un nom de compte vàlid"
      },
      "LANGUAGE": {
        "LABEL": "Idioma del lloc",
        "PLACEHOLDER": "El nom del vostre compte",
        "ERROR": ""
      },
      "DOMAIN": {
        "LABEL": "Domini de correu electrònic entrant",
        "PLACEHOLDER": "El domini on rebràs els correus electrònics",
        "ERROR": ""
      },
      "SUPPORT_EMAIL": {
        "LABEL": "Correu electrònic d'assistència",
        "PLACEHOLDER": "Correu electrònic d'assistència de la vostra companya",
        "ERROR": ""
      },
      "AUTO_RESOLVE_DURATION": {
        "LABEL": "El nombre de dies després que un ticket es resolgui automàticament si no hi ha activitat",
        "NOTE": "Nombre d'hores d'inactivitat després de les quals qualsevol conversa oberta es resoldrà automàticament.",
        "PLACEHOLDER": "30",
        "ERROR": "Introduïu una durada de resolució automàtica vàlida (mínim 1 dia i màxim 999 dies)"
      },
      "AUTO_RESOLVE_EMPTY_DURATION": {
        "LABEL": "Nombre de dies després dels quals una conversa buida s'ha de resoldre automàticament si no hi ha activitat",
        "PLACEHOLDER": "mai",
        "ERROR": "Introdueix una durada de resolució automàtica vàlida per a converses buides (mínim 1 dia i màxim 999 dies)"
      },
      "FEATURES": {
        "INBOUND_EMAIL_ENABLED": "La continuïtat de converses amb correus electrònics està habilitada per al vostre compte.",
        "CUSTOM_EMAIL_DOMAIN_ENABLED": "Ara podeu rebre correus electrònics al vostre domini personalitzat."
      },
      "PHONE": {
        "TITLE": "Configuració del PBX",
        "NOTE": "Configura la connexió amb el teu PBX per a trucades telefòniques",
        "SIP_HOST": {
          "LABEL": "Domini SIP"
        },
        "DIALING_MODE": {
          "LABEL": "Mode de marcatge",
          "MODES": {
            "direct": "Directe: la trucada es marca immediatament en fer clic a l'enllaç telefònic",
            "indirect": "Indirecte: el número de telèfon es prepara al quadre d'entrada del widget telefònic"
          }
        },
        "CALL_RECORDING_ACCESS": {
          "LABEL": "Accés a l'enregistrament de trucades",
          "MODES": {
            "admin_only": "Només administradors",
            "admin_and_assigned_agent": "Administradors i agent assignat",
            "inbox_members": "Tots els agents amb accés a la safata d'entrada"
          }
        }
      },
      "EMAIL": {
        "TITLE": "Configuració del correu electrònic",
        "NOTE": "Modifica el comportament de les safates d'entrada de correu electrònic"
      },
      "CONVERSATION_TIMESTAMP_DISPLAY_MODE": {
        "LABEL": "Mode de visualització de la marca horària de la conversa",
        "MODES": {
          "both": "Creació i última activitat",
          "last_activity_only": "Només l'última activitat",
          "last_customer_message": "Darrer missatge del client"
        }
      },
      "BLOCK_DOMAINS_WITH_LOW_REPUTATION": {
        "LABEL": "Bloqueja dominis amb baixa reputació"
      },
      "INCLUDE_PREVIOUS_EMAIL_MESSAGE": {
        "LABEL": "Inclou el missatge original a la resposta del correu electrònic"
      },
      "RESOLVE_NEW_CONVERSATION": {
        "LABEL": "Resol automàticament una conversa nova"
      },
      "MOVE_CONVERSATIONS_BY_ORDERS": {
        "LABEL": "Mou automàticament una conversa de correu nova a la safata del robot que va processar les comandes del contacte"
      },
      "EXTENDED_LABELS": {
        "LABEL": "Etiquetes ampliades: permet noms d'etiqueta més llargs amb una interfície emergent més gran"
      },
      "ENABLE_LAST_AGENT": {
        "LABEL": "LastAgent: assigna automàticament la conversa a l'agent que va enviar l'última resposta"
      },
      "PUSH_NOTIFICATION_MODE": {
        "LABEL": "Mode de notificacions push",
        "MODES": {
          "all_inboxes": "Totes les safates d'entrada: envia notificacions per a tots els tipus de canal",
          "chat_only": "Només xat: envia notificacions només per als canals que no són de correu electrònic"
        }
      },
      "ALLOW_TOGGLE_SIGNATURE": {
        "LABEL": "Permet activar o desactivar la signatura als missatges enviats"
      },
      "WALLBOARD_CHAT_STATUS_ENABLED": {
        "LABEL": "Mostra l'estat de xat de l'agent al wallboard"
      },
      "SHOW_FULL_ATTACHMENT_NAMES": {
        "LABEL": "Mostra els noms complets dels adjunts sense truncar"
      },
      "PASSWORD_LOGIN_MODE": {
        "LABEL": "Inici de sessió amb contrasenya",
        "MODES": {
          "allowed_for_all": "Permès per a tots els usuaris",
          "allowed_for_agents_only": "Permès només per als agents (els administradors han d'utilitzar OAuth)",
          "password_login_disabled": "Desactivat: només OAuth"
        }
      }
    },
    "NEW_VERSION_AVAILABLE": "Hi ha una nova versió disponible. Recarrega per obtenir les últimes actualitzacions.",
    "RELOAD_NOW": "Actualitza ara",
    "LEARN_MORE": "Aprèn més",
    "PAYMENT_PENDING": "El teu pagament està pendent. Actualitzeu la vostra informació de pagament per continuar utilitzant aquest programari",
    "LIMITS_UPGRADE": "El teu compte ha superat els límits d'ús, actualitza el pla per continuar utilitzant aquest programari",
    "OPEN_BILLING": "Obrir facturació"
  },
  "FORMS": {
    "MULTISELECT": {
      "ENTER_TO_SELECT": "Presiona retorn (tecla enter) per seleccionar",
      "ENTER_TO_REMOVE": "Presiona retorn (tecla enter) per eliminar",
      "NO_OPTIONS": "La llista és buida",
      "NO_RESULT": "No s'han trobat resultats",
      "SELECT_ONE": "Selecciona un",
      "SELECT": "Selecciona"
    }
  },
  "NOTIFICATIONS_PAGE": {
    "HEADER": "Notificacions",
    "MARK_ALL_DONE": "Marca Tot Fet",
    "DELETE_TITLE": "eliminat",
    "UNREAD_NOTIFICATION": {
      "TITLE": "Notificacions no llegides",
      "ALL_NOTIFICATIONS": "Veure totes les notificacions",
      "LOADING_UNREAD_MESSAGE": "S'estan carregant les notificacions no llegides...",
      "EMPTY_MESSAGE": "No tens notificacions no llegides"
    },
    "LIST": {
      "LOADING_MESSAGE": "Carregant notificacions...",
      "404": "Cap Notificació",
      "TABLE_HEADER": [
        "Nom",
        "Número de telèfon",
        "Converses",
        "Darrer contacte"
      ]
    },
    "TYPE_LABEL": {
      "conversation_creation": "Nova conversació",
      "conversation_assignment": "Conversació Assignada",
      "assigned_conversation_new_message": "Missatge Nou",
      "participating_conversation_new_message": "Missatge Nou",
      "conversation_mention": "Menció",
      "sla_missed_first_response": "SLA perdut",
      "sla_missed_next_response": "SLA perdut",
      "sla_missed_resolution": "SLA perdut"
    }
  },
  "NETWORK": {
    "NOTIFICATION": {
      "OFFLINE": "Fora de línia",
      "RECONNECTING": "Reconnectant...",
      "RECONNECT_SUCCESS": "Reconnectat"
    },
    "BUTTON": {
      "REFRESH": "Actualitza"
    },
    "CONNECTION_LOST": {
      "TITLE": "S'ha perdut la connexió",
      "DESCRIPTION": "No hem pogut connectar amb el servidor. Comprova la connexió i torna-ho a provar.",
      "RETRY": "Torna-ho a provar"
    }
  },
  "COMMAND_BAR": {
    "SEARCH_PLACEHOLDER": "Cerca o salta a",
    "SECTIONS": {
      "GENERAL": "General",
      "REPORTS": "Informes",
      "CONVERSATION": "Conversa",
      "BULK_ACTIONS": "Accions massives",
      "CHANGE_ASSIGNEE": "Canvia l'assignat",
      "CHANGE_PRIORITY": "Canvia la prioritat",
      "CHANGE_TEAM": "Canvia l'equip",
      "SNOOZE_CONVERSATION": "Posposa la conversa",
      "EXECUTE_MACRO": "Executa una macro",
      "ADD_LABEL": "Afegeix una etiqueta a la conversa",
      "REMOVE_LABEL": "Elimina l'etiqueta de la conversa",
      "SETTINGS": "Configuracions",
      "AI_ASSIST": "Assistència IA",
      "APPEARANCE": "Aparença",
      "SNOOZE_NOTIFICATION": "Posposa la notificació"
    },
    "COMMANDS": {
      "GO_TO_CONVERSATION_DASHBOARD": "Vés al Tauler de converses",
      "GO_TO_CONTACTS_DASHBOARD": "Ves al Tauler de contactes",
      "GO_TO_REPORTS_OVERVIEW": "Ves a Visió general dels informes",
      "GO_TO_CONVERSATION_REPORTS": "Vés a Informes de converses",
      "GO_TO_AGENT_REPORTS": "Ves a Informes d'agents",
      "GO_TO_LABEL_REPORTS": "Ves a Informes d'etiquetes",
      "GO_TO_INBOX_REPORTS": "Ves a Informes de la safata d'entrada",
      "GO_TO_TEAM_REPORTS": "Ves a Informes d'equip",
      "GO_TO_SETTINGS_AGENTS": "Ves a Configuració de l'agent",
      "GO_TO_SETTINGS_TEAMS": "Ves a Configuració de l'equip",
      "GO_TO_SETTINGS_INBOXES": "Ves a Configuració de la safata d'entrada",
      "GO_TO_SETTINGS_LABELS": "Ves a Configuració de l'etiqueta",
      "GO_TO_SETTINGS_CANNED_RESPONSES": "Ves a Configuració de resposta enllaunada",
      "GO_TO_SETTINGS_APPLICATIONS": "Ves a Configuració de l'aplicació",
      "GO_TO_SETTINGS_ACCOUNT": "Ves a Configuració del compte",
      "GO_TO_SETTINGS_PROFILE": "Ves a Configuració del perfil",
      "GO_TO_NOTIFICATIONS": "Ves a Notificacions",
      "ADD_LABELS_TO_CONVERSATION": "Afegeix una etiqueta a la conversa",
      "ASSIGN_AN_AGENT": "Assigna un agent",
      "AI_ASSIST": "Assistència IA",
      "ASSIGN_PRIORITY": "Assigna prioritat",
      "ASSIGN_A_TEAM": "Assigna un equip",
      "EXECUTE_A_MACRO": "Executa una macro",
      "MUTE_CONVERSATION": "Silencia la conversa",
      "UNMUTE_CONVERSATION": "No silenciïs la conversa",
      "REMOVE_LABEL_FROM_CONVERSATION": "Elimina l'etiqueta de la conversa",
      "REOPEN_CONVERSATION": "Torna a obrir la conversa",
      "RESOLVE_CONVERSATION": "Resol la conversa",
      "SEND_TRANSCRIPT": "Envia la transcripció per correu electrònic",
      "SNOOZE_CONVERSATION": "Posposa la conversa",
      "UNTIL_NEXT_REPLY": "Fins a la propera resposta",
      "UNTIL_NEXT_WEEK": "Fins a la setmana vinent",
      "UNTIL_TOMORROW": "Fins demà",
      "UNTIL_NEXT_MONTH": "Fins al mes vinent",
      "AN_HOUR_FROM_NOW": "Fins d'aquí una hora",
      "UNTIL_CUSTOM_TIME": "Personalitzat...",
      "CHANGE_APPEARANCE": "Canvia l'aparença",
      "LIGHT_MODE": "Clar",
      "DARK_MODE": "Fosc",
      "SYSTEM_MODE": "Sistema",
      "SNOOZE_NOTIFICATION": "Posposa la notificació"
    }
  },
  "DASHBOARD_APPS": {
    "LOADING_MESSAGE": "S'està carregant l'aplicació Tauler..."
  },
  "COMMON": {
    "OR": "O",
    "CLICK_HERE": "clica aquí"
  }
}
